import { useAuthStore } from '../../store/authStore'

const Welcome = () => {
  const { user } = useAuthStore()

  return (
    <div className="flex-1 flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900 mb-6">
          <svg className="h-10 w-10 text-primary-600 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Welcome back, {user?.username}!
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Select a chat from the sidebar to start messaging, or create a new chat to connect with friends.
        </p>

        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Getting Started
          </h3>
          
          <div className="space-y-3 text-left">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <span className="text-primary-600 dark:text-primary-400 text-sm font-medium">1</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Click the <strong>+</strong> button to create a new chat or group
              </p>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <span className="text-primary-600 dark:text-primary-400 text-sm font-medium">2</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Use the search function to find messages and conversations
              </p>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <span className="text-primary-600 dark:text-primary-400 text-sm font-medium">3</span>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Share files, images, and use emojis to make your chats more engaging
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome